import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from '../containers/home/Home';
import Login from '../containers/auth/Login';
import InternalLogin from '../containers/auth/InternalLogin';
import ForgotPassword from '../containers/auth/ForgotPassword';
import ResetPassword from '../containers/auth/ResetPassword';
import LoginCallback from '../containers/auth/LoginCallback';
import DriverLogin from '../containers/auth/driver/Login';
import DriverSetPassword from '../containers/auth/driver/SetPassword';
import OnboardProvider from '../containers/onboard/OnboardProvider';
import NoAccess from '../containers/home/NoAccess';
import AuthRoute from './AuthRoute';
import { MagicLinkRoute } from './MagicLinkRoute';
import PrivateRoute from './PrivateRoute';
import * as uiSlice from '../data/ui.slice';
import { useAppDispatch } from '../hooks/useAppDispatch';
import Tier3TripPackages from '../components/home/providers/Tier3TripPackages';
import { AttestTripsTier3 } from '../components/home/attestation/AttestTripsTier3';

const AppRouting = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(uiSlice.setFAQContext(location.pathname));
  }, [location]);

  return (
    <Routes>
      <Route path="/loginCallback" element={<LoginCallback />} />
      <Route
        path="/login"
        element={
          <AuthRoute>
            <Login />
          </AuthRoute>
        }
      />
      <Route
        path="/internallogin"
        element={
          <AuthRoute>
            <InternalLogin />
          </AuthRoute>
        }
      />
      <Route
        path="/forgotPassword"
        element={
          <AuthRoute>
            <ForgotPassword />
          </AuthRoute>
        }
      />
      <Route
        path="/activateUser"
        element={
          <AuthRoute>
            <ResetPassword activate={true} />
          </AuthRoute>
        }
      />
      <Route
        path="/driver/login"
        element={
          <AuthRoute>
            <DriverLogin />
          </AuthRoute>
        }
      />
      <Route
        path="/driver/setPassword"
        element={
          <AuthRoute>
            <DriverSetPassword />
          </AuthRoute>
        }
      />
      <Route path="/onboardProvider/:email" element={<OnboardProvider />} />
      <Route path="/onboardProvider" element={<OnboardProvider />} />
      <Route
        path="/tier3/package/:magicLinkId/:uuid"
        element={
          <MagicLinkRoute>
            <Tier3TripPackages />
          </MagicLinkRoute>
        }
      />
      <Route
        path="/tier3/attestation/:magicLinkId"
        element={
          <MagicLinkRoute>
            <AttestTripsTier3 />
          </MagicLinkRoute>
        }
      />
      <Route path="/noaccess" element={<NoAccess />} />
      <Route
        path="*"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AppRouting;
